import React from "react";
import { Form, Input, Button, Modal, Icon, Tag, message } from "antd";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { get } from 'lodash';
import Lib from '../../Lib/Utils';
import SelectQuery from '../../Lib/SelectQuery';


const FormItem = Form.Item;

class ContactFormInit extends React.Component {
  state = {
    contact: {},
  };

  componentDidMount() {
    let token = localStorage.getItem('token');
    axios.defaults.xsrfCookieName = 'csrftoken'
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem('language'),
      Authorization: `Token ${token}`,
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    // e.stopPropagation();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.handleFormSubmit(
          values,
          e,
          this.props.requestType,
          this.props.data.id
        )
        console.log('Received values of form: ', values);
      }
    });
  };

  handleFormSubmit = (values, event, requestType, contactID) => {
    const { lead, t } = this.props
    const postObj = {
      first_name: values.first_name,
      last_name: values.last_name,
      email: values.email,
      phone: values.phone,
      leads: values.leads.map(e => e.key),
    };

    if (requestType === "post") {
      if (lead)
        postObj.leads = lead.id
      axios.post(process.env.REACT_APP_AXIOS_URL + "/api/contacts/create/", postObj)
        .then(res => {
          if (res.status === 201) {
            message.success(t('contacts.contact_form.created', 'Contact successfully created'))
            this.props.handleState('modalVisible', false);
            this.props.fetch();
          }
        })
    } else if (requestType === "put") {
      axios.put(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/update/`, postObj)
        .then(res => {
          if (res.status === 200) {
            message.success(t('contacts.contact_form.updated', 'Contact successfully updated'))
            this.props.handleState('modalVisible', false);
            this.props.fetch();
          }
        })
    }

  };

  handleDelete = event => {
    event.preventDefault();
    const contactID = this.props.match.params.contactID;
    axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/delete/`)
      .then(res => {
        if (res.status === 204 || res.status === 200) {
          this.props.fetch();
        }
      })
  };

  renderLead(N) {
    return N.map((a, i) =>
      <Tag key={i} style={{ borderRadius: '0px' }}>{a.name}</Tag>
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { onCancel, requestType, visible, btnText, titleText, t, data } = this.props;

    let footer = [];
    if (requestType === 'post' || requestType === 'put') {
      footer = [
        <Button key="back" onClick={onCancel}>
          {t('general.cancel', "Cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={this.handleSubmit}>
          {btnText}
        </Button>,
      ];
    } else {
      footer = [
        <Button key="back" onClick={onCancel}>
          {t('general.cancel', "Cancel")}
        </Button>
      ];
    }
    return (
      <Modal
        visible={visible}
        title={titleText}
        onCancel={onCancel}
        footer={footer}
      >
        <Form layout="vertical" id='contact-form' hideRequiredMark onSubmit={this.handleSubmit}>
          <Form.Item label={t('contacts.contact_form.first_name', "First name")}>
            {
              requestType === 'get' ?
                <span className="ant-form-text">{data.first_name}</span> :
                getFieldDecorator('first_name', {
                  initialValue: data.first_name,
                  rules: [{ required: true, message: t('contacts.contact_form.first_name_required', "Please input the first name of contact!") }],
                })(<Input name="first_name" type="text" />)
            }
          </Form.Item>
          <Form.Item label={t('contacts.contact_form.last_name', "Last name")}>
            {
              requestType === 'get' ?
                <span className="ant-form-text">{data.last_name}</span> :
                getFieldDecorator('last_name', {
                  initialValue: data.last_name,
                  rules: [{ required: true, message: t('contacts.contact_form.last_name_required', "Please input the last name of contact!") }],
                })(<Input type="text" name="last_name" />)
            }
          </Form.Item>
          <FormItem label={t('contacts.contact_form.email', "Email")}>
            {
              requestType === 'get' ?
                <span className="ant-form-text">{data.email}</span> :
                getFieldDecorator('email', {
                  initialValue: data.email,
                  rules: [{
                    type: 'email', message: t('contacts.contact_form.email_invalid', "The input is not valid email!"),
                  }],
                })(<Input name="email" />)
            }
          </FormItem>
          <FormItem label={t('contacts.contact_form.phone', "Phone")}>
            {
              requestType === 'get' ?
                <span className="ant-form-text">{data.phone}</span> :
                getFieldDecorator('phone', {
                  initialValue: data.phone,
                  rules: [{

                  }],
                })(<Input type="text" name="phone" />)
            }
          </FormItem>
          <FormItem label={t('layout.menu.leads', "Leads")}>
            {
              requestType === 'get' ?
                <span className="ant-form-text">
                  {this.renderLead(data.leads)}
                </span> :
                getFieldDecorator('leads', {
                  initialValue: Lib.setSelectValueMultiple(get(data, 'leads'), 'id', 'name')
                })(
                  <SelectQuery
                    urlKey={`lead-list-autocomplete`}
                    // paramProps={this.props.paramProps}
                    placeholder=""
                    token={localStorage.getItem('token')}
                    suffixIcon={<Icon type="caret-down" />}
                    valKey={'id'}
                    valLabel={'name'}
                    mode="multiple"
                  // style={{ maxWidth: '71%', marginRight: '10px' }}
                  // dropdownClassName={this.props.dropdownClassName} // untuk styling dropdown by class
                  />
                )
            }
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

const ContactForm = Form.create()(withTranslation()(ContactFormInit));
<ContactForm wrappedComponentRef={(form) => this.form = form} />
this.form
export default withRouter(ContactForm);


// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactForm.js